'use client';

import { useHeaderActionsStore } from 'stores/headerActionsStore';

import { PageFooter } from './PageFooter';

export const PageFooterClient = () => {
  const hideFooter = useHeaderActionsStore(state => state.hideFooter);

  if (hideFooter) {
    return null;
  }

  return <PageFooter />;
};
